import {collectAllRequiredCheckboxes} from '../bin/elements';

const initialiseForm = () => {
  applyInputEventListeners();
};

const applyInputEventListeners = () => {
  // Input Element
  const pledgeName = document.getElementById('js:pledge__name');
  pledgeName.addEventListener(
    'input',
    (e) => {
      determineIfFormIsAccepted();
      updateSocialMediaValues(pledgeName.value);
    },
    true,
  );

  // Checkboxes
  const requiredCheckboxes = collectAllRequiredCheckboxes();
  requiredCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener(
      'change',
      () => {
        determineIfFormIsAccepted();
      },
      true,
    );
  });
};

const updateSocialMediaValues = (value) => {
  // let linkFacebook = document.getElementById('js:facebook-link');
  // linkFacebook.setAttribute(
  //   'href',
  //   'https://www.facebook.com/sharer/sharer.php?u=https://dontfeedthefill.com.au',
  // );
  let linkTwitter = document.getElementById('js:twitter-link');
  linkTwitter.setAttribute(
    'href',
    'http://twitter.com/share?text=' +
      encodeURIComponent(`I, ${value}, am a container saver! With Containers for Change, I'm making sure my 10c drink containers don’t go to landfill.
#dontfeedthefill
Want to join me? You can become a container saver too >>`) +
      '&url=http://dontfeedthefill.com.au',
  );
};

const determineIfAllRequiredCheckboxesAreEnabled = () => {
  const requiredCheckboxes = collectAllRequiredCheckboxes();
  return requiredCheckboxes.filter((checkbox) => {
    return !checkbox.checked;
  });
};

const determineIfFormIsAccepted = () => {
  if (determineIfAllRequiredCheckboxesAreEnabled().length !== 0) {
    document.getElementById('js:pledge-warning').classList.remove('hidden');
    document.getElementById('js:pledge-warning').focus();
  } else {
    document.getElementById('js:pledge-warning').classList.add('hidden');
  }
  if (
    document.getElementById('js:pledge__name').value.length > 0 &&
    determineIfAllRequiredCheckboxesAreEnabled().length === 0
  ) {
    document.getElementById('js:pledge-continue').removeAttribute('disabled');
  } else {
    document.getElementById('js:pledge-continue').setAttribute('disabled', true);
  }
};

exports.initialiseForm = initialiseForm;
